import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import './VehicleDetails.css';
import "./Navbar.css";
import { NavLink } from "react-router-dom";
import Calculator from "../Components/Calculator";
import ReviewCarousel from "../Components/ReviewCarousel";
import whatsapp from './assets/whatsapp.png';

const VehicleDetails = () => {
    const { carId } = useParams();
    const [carDetails, setCarDetails] = useState(null);
    const [carImages, setCarImages] = useState([]);
    const [mainImageIndex, setMainImageIndex] = useState(0);
    const [thumbnailIndex, setThumbnailIndex] = useState(0);
    const [touchStartX, setTouchStartX] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [dragStartX, setDragStartX] = useState(0);

    useEffect(() => {
        fetch(`https://api.saadmotors.com/get-car-details-with-images.php?id=${carId}`)
            .then(response => response.json())
            .then(data => {
                setCarDetails(data.carDetails);
                setCarImages([data.carDetails.images, ...data.carImages.map(img => img.image_path)]);
            })
            .catch(error => {
                console.error("Error fetching car details:", error);
            });
    }, [carId]);

    const handleThumbnailClick = (index) => {
        setMainImageIndex(index);
    };

    const handleArrowClick = (direction) => {
        if (direction === 'left') {
            setMainImageIndex((prevIndex) => (prevIndex === 0 ? carImages.length - 1 : prevIndex - 1));
        } else if (direction === 'right') {
            setMainImageIndex((prevIndex) => (prevIndex === carImages.length - 1 ? 0 : prevIndex + 1));
        }
    };

    // const handleDownloadImages = async () => {
    //     const imageUrl = `https://api.saadmotors.com/${carImages[0]}`;
    //     const res = await fetch(imageUrl);
    //     const blob = await res.blob();
    //     const url = URL.createObjectURL(blob);
    //     const a = document.createElement("a");
    //     a.href = url;
    //     a.download = "test.jpg";
    //     a.click();
    //     URL.revokeObjectURL(url);
    // };

    const handleDownloadImages = async () => {
  if (!carImages || carImages.length === 0) {
    alert("No images available to download.");
    return;
  }

  try {
    for (let i = 0; i < carImages.length; i++) {
      const imageUrl = `https://api.saadmotors.com/${carImages[i]}`;
      const response = await fetch(imageUrl);

      if (!response.ok) {
        console.error("Failed to download:", imageUrl);
        continue;
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      const extension =
        new URL(imageUrl).pathname.match(/\.(jpg|jpeg|png|webp|gif|avif)$/i)?.[0] || ".jpg";

      const a = document.createElement("a");
      a.href = url;
      a.download = `car-image-${i + 1}${extension}`;

      document.body.appendChild(a);
      a.click();
      a.remove();

      await new Promise((resolve) => setTimeout(resolve, 300));
      URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error("Error downloading images:", error);
    alert("Unable to download images. Please try again.");
  }
};

    // const handleThumbnailArrowClick = (direction) => {
    //     if (direction === 'left') {
    //         setThumbnailIndex((prevIndex) => (prevIndex === 0 ? carImages.length - 1 : prevIndex - 1));
    //     } else if (direction === 'right') {
    //         setThumbnailIndex((prevIndex) => (prevIndex === carImages.length - 1 ? 0 : prevIndex + 1));
    //     }
    // };

    const handleThumbnailArrowClick = (direction) => {
        if (direction === "left") {
            setThumbnailIndex((prev) => Math.max(prev - 1, 0));
        } else {
            setThumbnailIndex((prev) => prev + 1);
        }
    };

    const handleTouchStart = (e) => {
        setTouchStartX(e.touches[0].clientX);
    };

    const handleTouchMove = (e) => {
        if (touchStartX === 0) return;

        const touchEndX = e.touches[0].clientX;
        const deltaX = touchStartX - touchEndX;

        if (deltaX > 50) {
            handleArrowClick('right');
            setTouchStartX(0);
        } else if (deltaX < -50) {
            handleArrowClick('left');
            setTouchStartX(0);
        }
    };

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setDragStartX(e.clientX);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;

        const dragEndX = e.clientX;
        const deltaX = dragStartX - dragEndX;

        if (deltaX > 50) {
            handleArrowClick('right');
            setIsDragging(false);
        } else if (deltaX < -50) {
            handleArrowClick('left');
            setIsDragging(false);
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    if (!carDetails) {
        return <div>Loading...</div>;
    }

    const requiredFeatures = [
        "abs",
        "airbag",
        "bluetooth",
        "cdPlayer",
        "dvd",
        "tv",
        "powerSteering",
        "powerWindow",
        "sunRoof",
        "leatherSeat",
        "alloyWheels",
        "ac",
        "radio",
        "caChanger",
        "powerSeat",
        "backTire",
        "grillGuard",
        "rearSpoiller",
        "centralLock",
        "jack",
        "spareTire",
        "wheelSpanner",
        "fogLights",
        "backCamera",
        "pushStart",
        "keylessEntry",
        "esc",
        "cam360deg",
        "bodyKit",
        "sideAirbag",
        "powerMirror",
        "sideSkirts",
        "frontLip",
        "navigation",
        "turbo",
        "powerDoor",
    ];

    const features = JSON.parse(carDetails.features || "{}");

    // Merge required features with database features
    const allFeatures = requiredFeatures.reduce((acc, feature) => {
        acc[feature] = features[feature] || false; // Default to false if feature is not in the database
        return acc;
    }, {});

    const featureNames = Object.keys(allFeatures);

    const chunkArray = (array, size) => {
        const result = [];
        for (let i = 0; i < array.length; i += size) {
            result.push(array.slice(i, i + size));
        }
        return result;
    };

    const featureRows = chunkArray(featureNames, 4);

    return (
        <>
        <div className="row">
            <div className="col-12 middlecols">
                <div className="container-fluid my-4">
                    <div className="row">
                        <div className="col-md-8">
                            <div className="main-image-container">
                                <img
                                    src={`https://api.saadmotors.com/${carImages[mainImageIndex]}`}
                                    alt={carDetails.model}
                                    className="img-fluid main-image"
                                    onTouchStart={(e) => handleTouchStart(e)}
                                    onTouchMove={(e) => handleTouchMove(e)}
                                    onMouseDown={(e) => handleMouseDown(e)}
                                    onMouseMove={(e) => handleMouseMove(e)}
                                    onMouseUp={handleMouseUp}
                                    onMouseLeave={handleMouseUp}
                                />
                                <div className="arrow left-arrow" onClick={() => handleArrowClick('left')}>&#10094;</div>
                                <div className="arrow right-arrow" onClick={() => handleArrowClick('right')}>&#10095;</div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-1">  <div className="thumbnail-arrow left-arrow" onClick={() => handleThumbnailArrowClick('left')}>&#10094;</div></div>
                                <div className="col-md-10">
                                    <div className="thumbnail-container">
                                       <div className="thumbnail-wrapper"
                                        style={{ transform: `translateX(-${thumbnailIndex * 110}px)` }}
                                        >
                                        {carImages.map((image, index) => (
                                            <img
                                            key={index}
                                            src={`https://api.saadmotors.com/${image}`}
                                            alt={`${carDetails.model} ${index}`}
                                            className={`thumbnail ${index === mainImageIndex ? "active" : ""}`}
                                            onClick={() => handleThumbnailClick(index)}
                                            />
                                        ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-1"><div className="thumbnail-arrow right-arrow" onClick={() => handleThumbnailArrowClick('right')}>&#10095;</div></div>
                            </div>
                            <div class="vehicle-header">
                                <h3 className="text-center fw-bold text-uppercase py-2">Vehicle Specification</h3>
                            </div>
                            
                            <div className="row mt-2" id="vehicle_det">
                                <div className="col-md-6">

                                    <strong className="mb-5 fw-bold d-none">Vehicle Details:</strong>
                                    <div className="row mb-3 border-bottom p-2">
                                        <div className="col-md-4 fw-bold text-center">Maker:</div>
                                        <div className="col-md-8">{carDetails.maker}</div>
                                    </div>

                                    <div className="row mb-3 border-bottom p-2">
                                        <div className="col-md-4 fw-bold text-center">Model:</div>
                                        <div className="col-md-8">{carDetails.model}</div>
                                    </div>

                                    <div className="row mb-3 border-bottom p-2">
                                        <div className="col-md-4 fw-bold text-center">Color:</div>
                                        <div className="col-md-8">{carDetails.color}</div>
                                    </div>

                                    <div className="row mb-3 border-bottom p-2">
                                        <div className="col-md-4 fw-bold text-center">Body Type:</div>
                                        <div className="col-md-8">{carDetails.body_type}</div>
                                    </div>

                                    <div className="row mb-3 border-bottom p-2">
                                        <div className="col-md-4 fw-bold text-center">Doors:</div>
                                        <div className="col-md-8">{carDetails.doors}</div>
                                    </div>

                                </div>


                                 <div className="col-md-6">

                                    <strong className="mb-5 fw-bold d-none">Specification:</strong>
                                    <div className="row mb-3 border-bottom p-2">
                                        <div className="col-md-4 fw-bold text-center">Version:</div>
                                        <div className="col-md-8">{carDetails.version}</div>
                                    </div>

                                    <div className="row mb-3 border-bottom p-2">
                                        <div className="col-md-4 fw-bold text-center">M3:</div>
                                        <div className="col-md-8">{carDetails.m3}</div>
                                    </div>

                                    <div className="row mb-3 border-bottom p-2">
                                        <div className="col-md-4 fw-bold text-center">Weight:</div>
                                        <div className="col-md-8">{carDetails.weight} kg</div>
                                    </div>

                                    <div className="row mb-3 border-bottom p-2">
                                        <div className="col-md-4 fw-bold text-center">Chassis:</div>
                                        <div className="col-md-8">{carDetails.vin}</div>
                                    </div>

                                    <div className="row mb-3 border-bottom p-2">
                                        <div className="col-md-4 fw-bold text-center">Engine:</div>
                                        <div className="col-md-8">{carDetails.engine} cc</div>
                                    </div>

                                </div>
                            </div>

                            <div className="specs-table my-4 d-none">
                                <strong>Vehicle Details:</strong>
                                        
                                <table className="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <th>Month/Year</th>
                                            <td>{carDetails.year}</td>
                                            <th>Color</th>
                                            <td>{carDetails.color}</td>
                                        </tr>
                                        <tr>
                                            <th>Engine</th>
                                            <td>{carDetails.engine} cc</td>
                                            <th>Chassis</th>
                                            <td>{carDetails.vin}</td>
                                        </tr>
                                        <tr>
                                            <th>Model Code</th>
                                            <td>{carDetails.model_code}</td>
                                            <th>Maker</th>
                                            <td>{carDetails.maker}</td>
                                        </tr>
                                        <tr>
                                            <th>Model</th>
                                            <td>{carDetails.model}</td>
                                            <th>Price</th>
                                            <td>{carDetails.price}</td>
                                        </tr>
                                        
                                        <tr>
                                            <th>Dimension</th>
                                            <td>{carDetails.dimension}</td>
                                            <th>Weight</th>
                                            <td>{carDetails.weight} kg</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="specs-table my-4 d-none">
                                <strong>Specification:</strong>
                                <table className="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <th>Month/Year</th>
                                            <td>{carDetails.year}</td>
                                            <th>Color</th>
                                            <td>{carDetails.color}</td>
                                        </tr>
                                        <tr>
                                            <th>Mileage</th>
                                            <td>{carDetails.mileage} km</td>
                                            <th>Steering</th>
                                            <td>{carDetails.steering}</td>
                                        </tr>
                                        <tr>
                                            <th>Transmission</th>
                                            <td>{carDetails.transmission}</td>
                                            <th>Fuel</th>
                                            <td>{carDetails.fuel}</td>
                                        </tr>
                                        <tr>
                                            <th>Drive</th>
                                            <td>{carDetails.drive}</td>
                                            <th>Doors</th>
                                            <td>{carDetails.doors}</td>
                                        </tr>
                                        <tr>
                                            <th>Engine</th>
                                            <td>{carDetails.engine} cc</td>
                                            <th>Chassis</th>
                                            <td>{carDetails.vin}</td>
                                        </tr>
                                        <tr>
                                            <th>Model Code</th>
                                            <td>{carDetails.model_code}</td>
                                            <th>Maker</th>
                                            <td>{carDetails.maker}</td>
                                        </tr>
                                        <tr>
                                            <th>Model</th>
                                            <td>{carDetails.model}</td>
                                            <th>Price</th>
                                            <td>{carDetails.price}</td>
                                        </tr>
                                        <tr>
                                            <th>Country</th>
                                            <td>{carDetails.country}</td>
                                            <th>Version</th>
                                            <td>{carDetails.version}</td>
                                        </tr>
                                        <tr>
                                            <th>Location</th>
                                            <td>{carDetails.location}</td>
                                            <th>Seats</th>
                                            <td>{carDetails.seats}</td>
                                        </tr>
                                        <tr>
                                            <th>Dimension</th>
                                            <td>{carDetails.dimension}</td>
                                            <th>Weight</th>
                                            <td>{carDetails.weight} kg</td>
                                        </tr>
                                        <tr>
                                            <th>Stock ID</th>
                                            <td>{carDetails.stock_id}</td>
                                            <th>Body Type</th>
                                            <td>{carDetails.body_type}</td>
                                        </tr>
                                        <tr>
                                            <th>M3</th>
                                            <td>{carDetails.m3}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="features-section my-4">
                            <div class="vehicle-header">
                                <h3 className="text-center fw-bold text-uppercase py-2">Features</h3>
                            </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered mt-3 ftrs-opt">
                                        <tbody>
                                            {featureRows.map((row, rowIndex) => (
                                                <tr key={rowIndex}>
                                                    {row.map((feature, colIndex) => (
                                                        <td
                                                            key={colIndex}
                                                            style={{
                                                                backgroundColor: allFeatures[feature] ? '#00247D' : '#aaaaaa',
                                                                border: `1px solid ${allFeatures[feature] ? '#00247D' : '#ddd'}`,
                                                            }}
                                                        >
                                                            <div className="feature-label">
                                                                {feature}
                                                            </div>
                                                        </td>
                                                    ))}
                                                    {/* Fill empty cells if the last row has less than 4 features */}
                                                    {row.length < 4 && Array(4 - row.length).fill().map((_, index) => (
                                                        <td key={`empty-${index}`}></td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-4">
                            <Calculator />
                           <div className="whatsapp my-4">
                                <a href={`https://wa.me/66928368084?text=${encodeURIComponent("May I know more details about it...")}`} target="_blank"
                                rel="noopener noreferrer">
                                    <img src={whatsapp} alt='MI Cars' className="img-fluid main-image" />
                                </a>
                           </div>
                           <div className="topbars">
                                <span><NavLink to="#"><i class="fa fa-plus"></i>Favourite</NavLink></span>
                                <span>
                                    <button className="btn btn-link p-0" onClick={handleDownloadImages}>
                                        <i className="fa fa-download"></i> Download
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* <div className="container-fluid d-none mt-5 wow fadeInUp" data-wow-delay="0.4s">
            <div className="row">
                <div className="col-12">
                    <ReviewCarousel />
                </div>
            </div>
        </div> */}
        </>
    );
};

export default VehicleDetails;